module.exports = __webpack_public_path__ + "img/starthouse_signaturemenu_image04.68a528bf.jpg";